/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.maximizable()
    @Serenity.Decorators.registerClass()
    export class TaskDialog extends NoboxEntityDialog<TaskRow, any> {
        protected getFormKey() { return TaskForm.formKey; }
        protected getIdProperty() { return TaskRow.idProperty; }
        protected getLocalTextPrefix() { return TaskRow.localTextPrefix; }
        protected getNameProperty() { return TaskRow.nameProperty; }
        protected getService() { return TaskService.baseUrl; }
        protected getDeletePermission() { return TaskRow.deletePermission; }
        protected getInsertPermission() { return TaskRow.insertPermission; }
        protected getUpdatePermission() { return TaskRow.updatePermission; }
        public callbackSave: (res: TaskRow) => void;
        public callbackDelete: (id: any) => void;

        protected form = new TaskForm(this.idPrefix);

        constructor(container?: JQuery) {
            super(container);
            var initFile = false;
            this.form.Lampiran.element.parent().find("ul").on("DOMNodeInserted", function () {
                if (initFile == false) {
                    initFile = true;
                    $('ul li.file-item.file-image').each(function () {
                        var elIMage = $(this).find(".thumb ");
                        $(this).find(".thumb ").removeAttr("style");
                        $(this).find(".thumb ").css("overflow", "hidden");
                        var image = elIMage.attr("href");
                        elIMage.html(`<img src="${image}" style = "height: 100%;width: auto;overflow: hidden;margin:auto;" >`);
                    });
                    initFile = false;
                }
            });
            if (this.isNew()) {
                //Q.serviceCall({
                //    blockUI: false,
                //    url: "/Services/Administration/User/List",
                //    request: {
                //        EqualityFilter: { Username: Q.Authorization.username },
                //        IncludeColumns: ["DisplayName", "UserImage"],
                //        ColumnSelection: 1,
                //        Take: 1
                //    },
                //    onSuccess: (res) => {
                //        this.userLogin = res.Entities[0];
                //    }
                //});
                Administration.UserService.List({
                    IncludeColumns: ["DisplayName"],
                    ColumnSelection: 1,
                    EqualityFilter: { UserName: Q.Authorization.username }
                }, (res) => {
                    this.form.Owner.value = res.Entities[0].UserId.toString();
                });
            }
        }
        onDialogOpen() {
            super.onDialogOpen();
            this.element.closest('.ui-dialog').find('.ui-dialog-titlebar-maximize').click();
        }
        showBoard() {
            this.form.BoardId.element.toggle(true);
        }

        protected getToolbarButtons() {
            var btn = super.getToolbarButtons();
            btn[1].onClick = () => {

                this.save(response1 => {
                    if (this.isEditMode()) {
                        var id1 = response1.EntityId;
                        if (id1 == null) {
                            id1 = this.get_entityId();
                        }
                    }
                    else {
                    }

                    this.showSaveSuccessMessage(response1);
                });
            }
            return btn;
        }

        protected updateInterface() {
            super.updateInterface();
            if (this.get_entity()) {
                if (this.get_entity().ShowBoard == 1) {
                    this.form.BoardId.getGridField().toggle(true);
                }
            }
            if (!this.isEditMode()) {
                this.form.In.element.closest(".category").hide()
            }
        }

        protected save(callback?: (response: Serenity.SaveResponse) => void) {
            var res = {} as Serenity.SaveResponse;
            if (this.validateForm()) {
                if (this.isEditMode()) {
                    res.EntityId = this.get_entityId();
                } else {
                    res.EntityId = 325235235;
                }
                if (this.callbackSave != undefined) {
                    this.onSaveSuccess(res);
                    callback(res);
                } else {
                    if (this.isEditMode()) {
                        TaskService.Update({
                            EntityId: this.get_entityId(),
                            Entity: this.getSaveEntity()
                        }, (res) => {
                            Serenity.SubDialogHelper.triggerDataChange(this);
                            callback(res);
                        });
                    } else {
                        TaskService.Create({
                            Entity: this.getSaveEntity()
                        }, (res) => {
                            Serenity.SubDialogHelper.triggerDataChange(this);
                            callback(res);
                        });
                    }
                }
            }
        }
        protected onSaveSuccess(response: Serenity.SaveResponse): void {
            var item = this.getSaveEntity();
            item.ListNama = this.form.ListId.text;
            item.Id = response.EntityId;
            item.KontakNama = this.form.KontakId.text;
            this.callbackSave(item);
        }
        protected doDelete(callback?: (response: Serenity.DeleteResponse) => void) {
            var res = {} as Serenity.DeleteResponse;
            if (this.callbackDelete != undefined) {
                callback(res);
                this.onDeleteSuccess(res);
            } else {
                TaskService.Delete({
                    EntityId: this.get_entityId()
                }, (res) => {
                    Serenity.SubDialogHelper.triggerDataChange(this);
                    callback(res);
                });
            }
        }
        protected onDeleteSuccess(response: Serenity.DeleteResponse) {
            if (this.callbackDelete != undefined) {
                this.callbackDelete(this.get_entityId());
            }
        }
    }
}